export const TABLE_HEADERS = Object.freeze([
	'No.',
	'Customer Phone',
	'Consultant Name',
	'Market',
	'Payment Status',
	'Expired At',
	'1st Call Result',
	'1st Call Date',
	'2nd Call Result',
	'2nd Call Date',
]);
